import { BioCardGridProps } from '@ahc-digital/component-library';
import { getDroplink } from 'src/shared/param-utils';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { C56BiographyGridProps } from './C56BiographyGrid.types';

export function GetBiographyGridModel(props?: C56BiographyGridProps): BioCardGridProps {
  const { fields, params } = props || {};
  const { renderImage, renderText, renderLink } = useConditionalRendering();

  const mappedBios =
    fields?.Biographies?.map((bioItem) => {
      const { Image, Name, DetailedBioLink, Title } = bioItem.fields;

      return {
        image: renderImage(Image),
        name: renderText(Name),
        optionalLink: renderLink(DetailedBioLink),
        title: renderText(Title),
      };
    }) || [];

  return {
    bios: mappedBios,
    columnsDesktop: getDroplink(params?.GridNumberOfColumns, '4'),
    headline: renderText(fields?.Title),
    headlineTag: getDroplink(params?.HeadlineTag, 'p'),
  };
}
